import { useContext } from 'react';

import userStore from '@stores/user';

export const useCurrentAuthMethod = (): AuthMethod | null => useContext<UserStore>(userStore)?.state?.auth_method;
